module.exports = __webpack_public_path__ + "static/ha6-0873cba84d732382e79b651dcae692e2.jpg";